
import * as React from "react"

const MOBILE_BREAKPOINT = 640

export function useIsMobile() {
  // Default to false (desktop) on server and initial client render
  const [isMobile, setIsMobile] = React.useState<boolean>(false)
  const [hasMounted, setHasMounted] = React.useState<boolean>(false)

  React.useEffect(() => {
    setHasMounted(true)
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(mql.matches)
    }
    // Set initial value after mount
    onChange()
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  // Return the default value until mounted, then the actual client-side value
  return hasMounted ? isMobile : false;
}
